import { useEntitlements } from '~/hooks/account';

export const useCRMLabel = () => {
  const { hasAccessSettingsIntegrations } = useEntitlements();

  const crmLabel = hasAccessSettingsIntegrations ? 'HubSpot' : 'your CRM';

  return { crmLabel };
};
